import React, { useState } from 'react';
import { PopUpModal } from '@/common/components/modal/popupModal.component';
import LoginForm from './loginForm.component';
import OTPForm from './OTPForm.component';

interface LoginPopUpProps {
  isOpen: boolean;
  onCancel: () => void;
}
export default function LoginPopUp({ isOpen, onCancel }: LoginPopUpProps) {
  const [currentStep, setCurrentStep] = useState<'mobile' | 'otp'>('mobile');
  const steps = {
    mobile: {
      title: 'ورود یا ثبت نام',
      content: (
        <LoginForm
          showOTP={() => {
            setCurrentStep('otp');
          }}
        />
      ),
    },
    otp: {
      title: 'کد تایید',
      content: (
        <OTPForm
          setMobile={() => {
            setCurrentStep('mobile');
          }}
          endOperation={() => {
            onCancel();
            setCurrentStep('mobile');
          }}
        />
      ),
    },
  };

  return (
    <>
      <PopUpModal width={504} open={isOpen} onCancel={onCancel}>
        <div className="h-full w-full p-6">
          <h1 className="mb-4 w-full text-right text-lg font-semibold text-black-default">
            {steps[currentStep].title}
          </h1>
          {steps[currentStep].content}
        </div>
      </PopUpModal>
    </>
  );
}
